<template>
  <div class="client-row">

    <AvatarImage :image-path="client.photo_path"
                 :name="client.full_name"
                 :color-id="client.color_id"/>

    <div class="client-details">
      <div class="client-details__name">
        {{client.full_name}}
      </div>
      <div class="client-details__info"
           v-if="client.email">
        <v-icon>icon-At-Sign</v-icon>
        <span>{{client.email}}</span>
      </div>
      <div class="client-details__info"
           v-if="clientPhone">
        <v-icon>icon-Phone</v-icon>
        <span>{{clientPhone}}</span>
      </div>
    </div>

  </div>
</template>

<script>
  import {AvatarImage} from "@/modules/common/components";

  export default {
    name: "ClientRow",
    components: {AvatarImage},
    props: {
      client: {
        type: Object,
        required: true
      }
    },
    computed: {
      clientPhone() {
        return this.client.phone_to_display || this.client.notifications_phone_display_value;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";

  .client-row {
    display: flex;

    .avatar-wrapper {
      margin: 15px 10px;
      height: 40px;
      width: 40px;
    }

    .client-details {
      padding: 10px;

      &__name {
        font-size: 15px;
        font-weight: 600;
      }

      &__info {
        padding: 1px 0;
        font-weight: 500;
        color: $grey-color-5;
        font-size: 13px;

        .v-icon {
          font-size: 16px;
          top: -1px;
        }
      }
    }
  }
</style>
